import React from "react";
import { Link } from "react-router-dom";
import Custombutton from "../../utils/Custombutton";

const OrderConfirm = () => {
  return (
    <div className="buying dvpn">
      <div className="container pt-5">
        <div className="row ">
          <div className="col-lg-12  mb-4">
            <div className="position-relative  h-100">
              <div className="routers buy-router main-router  h-100">
                <div className="row align-items-start align-items-md-center h-100">
                  <div className="col-xxl-12 text-center p-5 p-xxl-12   ">
                    <div className="d-flex align-items-center justify-content-center w-100">
                      <h3>Congrats !!</h3>
                    </div>
                    <p>Your Order has been Placed</p>

                    <p>
                      A confirmation has been sent to your <br /> registered
                      email address
                    </p>
                    <div className="d-flex align-items-center flex-wrap justify-content-center gap-4 mb-5 mt-5">
                      <div className="copy-tracking-id flex-wrap">
                        <p className="mb-0">Your Tracking ID</p>
                        <h3 className="mb-0">4125487</h3>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="25"
                          height="24"
                          viewBox="0 0 25 24"
                          fill="none"
                        >
                          <path
                            d="M8 3H15.1C17.3402 3 18.4603 3 19.316 3.43597C20.0686 3.81947 20.6805 4.43139 21.064 5.18404C21.5 6.03969 21.5 7.15979 21.5 9.4V16.5M6.7 21H14.8C15.9201 21 16.4802 21 16.908 20.782C17.2843 20.5903 17.5903 20.2843 17.782 19.908C18 19.4802 18 18.9201 18 17.8V9.7C18 8.57989 18 8.01984 17.782 7.59202C17.5903 7.21569 17.2843 6.90973 16.908 6.71799C16.4802 6.5 15.9201 6.5 14.8 6.5H6.7C5.5799 6.5 5.01984 6.5 4.59202 6.71799C4.21569 6.90973 3.90973 7.21569 3.71799 7.59202C3.5 8.01984 3.5 8.57989 3.5 9.7V17.8C3.5 18.9201 3.5 19.4802 3.71799 19.908C3.90973 20.2843 4.21569 20.5903 4.59202 20.782C5.01984 21 5.5799 21 6.7 21Z"
                            stroke="white"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </div>
                      <Link to='/tracking-order'>
                      <Custombutton
                        label={"Track your order "}
                        style={{ zIndex: "9" }}
                        className={"btn-bg px-5 py-4 position-relative "}
                        />
                        </Link>
                    </div>
                    <div className=" d-flex align-items-center justify-content-center ">
                      <Link
                        to="/nebula-lite"
                        className="position-relative "
                        style={{ zIndex: "9" }}
                      >
                        <Custombutton
                          label={"learn more"}
                          className={
                            "btn-outline gradient-text gradient-outline px-5 py-3"
                          }
                        />
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6  mb-4">
            <div className="position-relative  h-100">
              <div className="routers buy-router  h-100">
                <div className="row align-items-start align-items-md-center h-100">
                  <div className="col-xxl-6 p-5 p-xxl-5 order-xxl-1 order-2">
                    <h3>Routers</h3>
                    <p>
                      Cosmic runs on a decentralized network of Nodes. Install
                      our PC package to operate a Node and earn passive income
                      through our rewards program.
                    </p>

                    <Link
                      to="/nebula-lite"
                      className="position-relative "
                      style={{ zIndex: "9" }}
                    >
                      <Custombutton
                        label={"learn more"}
                        className={
                          "btn-outline gradient-text gradient-outline px-5 py-3"
                        }
                      />
                    </Link>
                  </div>
                  <div className="col-xxl-6 order-xxl-2 order-1">
                    <div className="d-none d-lg-block">
                      <img
                        className="w-100"
                        src="./assets/images/router-new.png"
                        alt="router-new"
                      />
                    </div>
                    <div className="d-block d-lg-none">
                      <img
                        className="w-100"
                        src="./assets/images/router-new.png"
                        alt="router-new"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6  mb-4">
            <div className="position-relative  h-100">
              <div className="routers buy-router  h-100">
                <div className="row align-items-start align-items-md-center h-100">
                  <div className="col-xxl-6  order-xxl-1 order-2">
                    <div className="d-none d-xxl-block">
                      <img
                        className="w-100 position-relative z-index-1"
                        src="./assets/images/node-new.png"
                        alt="router-new"
                      />
                    </div>
                    <div className="d-block d-xxl-none">
                      <img
                        className="w-100  position-relative "
                        src="./assets/images/node-new.png"
                        alt="router-new"
                      />
                    </div>
                  </div>
                  <div className="col-xxl-6 p-5 p-xxl-5  order-xxl-2 order-2">
                    <h3>Nodes</h3>
                    <p>
                      Cosmic uses a decentralized Node network. Run a Node on
                      your PC and earn passive income through our rewards
                      program.
                    </p>

                    <Link
                      to="/nodes"
                      className="position-relative "
                      style={{ zIndex: "9" }}
                    >
                      <Custombutton
                        label={"learn more"}
                        className={
                          "btn-outline gradient-text gradient-outline px-5 py-3"
                        }
                      />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-12 ">
            <div className="text-center d-flex align-items-center justify-content-center">

            <Link
              to="/ "
              className="position-relative text-center"
              style={{ zIndex: "9" }}
            >
              <Custombutton
                label={"Go To Home"}
                className={
                  "btn-outline gradient-text gradient-outline px-5 py-3"
                }
                />
            </Link>
                </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderConfirm;
